/*
Fork addition (Stage I): the one mobile breakpoint for the whole
app. Every Stage I media query in the components uses the same
value — (max-width: 900px) — and this composable is its reactive
twin for the places that need JS state (drawer mode, conditional
menu items, tap-vs-drag selection). Above the breakpoint nothing
changes anywhere: the desktop layout is the primary experience,
mobile must never constrain it.
*/
import {createSharedComposable, useMediaQuery} from '@vueuse/core';

export const MOBILE_MEDIA_QUERY = '(max-width: 900px)';

export const useIsMobile = createSharedComposable(() => {
    const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY);
    return {isMobile};
});
